/**
 * Testsicht auf eine Rolle.
 *
 * Administratoren und Superadmins sehen die Anwendung mit ihren eigenen, weiten
 * Rechten – und damit nie das, was ein Hausmeister oder eine Disponentin
 * tatsächlich vor sich hat. Die Rollensicht beantwortet genau diese Frage,
 * ohne ein zweites Konto und ohne Abmelden.
 *
 * Die Wahl liegt im Browser und reist als Kopfzeile `X-Rollensicht` an jeder
 * Anfrage mit. Sie ist bewusst **keine** Rechteentscheidung: Der Server
 * schneidet damit die Rechte auf die Rolle zu und kann dabei ausschließlich
 * wegnehmen, nie hinzufügen (siehe `beschraenkeAufRolle` im Backend). Ein
 * manipulierter Wert führt deshalb höchstens dazu, dass jemand *weniger* sieht.
 *
 * Bewusst nicht im Zugriffstoken: Die Sicht soll ohne neue Anmeldung an- und
 * ausgehen, und ein Token, das weniger Rechte trägt, wäre 30 Minuten lang
 * nicht mehr loszuwerden.
 */

const KEY = 'ff.rollensicht';

export function getRollensicht(): number | null {
  const stored = localStorage.getItem(KEY);
  if (!stored) return null;
  const parsed = Number(stored);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

export function setRollensicht(rolle: number | null): void {
  if (rolle) localStorage.setItem(KEY, String(rolle));
  else localStorage.removeItem(KEY);
}
